import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import { Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {FormBuilder} from '@angular/forms';
import {TimeZoneService} from '@core/services/time-zone.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'lib-update-solution',
  templateUrl: './update-solution.component.html',
  styleUrls: ['./update-solution.component.scss']
})
export class UpdateSolutionComponent implements OnInit, OnDestroy {

  result: any;
  userName: string;
  updateSolutionForm: any;
  unSubscribe$ = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<UpdateSolutionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              private timeZoneService: TimeZoneService,
              private store: Store<AdminPanelState>) {
    this.result = {
      save: false,
      solution: null
    };
  }

  ngOnInit() {
    this.userName = this.data.userName;

    this.updateSolutionForm = this.formBuilder.group({
      product: [this.data.solution.ProductName],
      solution: [this.data.solution.SolutionName],
      isActive: [this.data.solution.IsActive === 'True'],
      expiryDate: [this.timeZoneService.getUTCDateWithoutTime(new Date(this.data.solution.ExpiryDate))]
    });

    this.updateSolutionForm.controls['product'].disable();
    this.updateSolutionForm.controls['solution'].disable();
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onSave() {
    if (this.updateSolutionForm.valid) {
      this.result.save = true;
      this.result.solution = this.data.solution;
      this.result.solution.IsActive = this.updateSolutionForm.value.isActive;
      this.result.solution.ExpiryDate = this.timeZoneService.getUTCDateWithoutTime(this.updateSolutionForm.value.expiryDate);
    }
  }

  addOneYear() {
    const currentExpiryDate = this.timeZoneService.getUTCDateWithoutTime(this.updateSolutionForm.value.expiryDate);
    const newExpiryDate = this.timeZoneService.getUTCDateWithoutTime(new Date(currentExpiryDate.getFullYear() + 1, currentExpiryDate.getMonth(), currentExpiryDate.getDate()));
    this.updateSolutionForm.controls['expiryDate'].setValue(newExpiryDate);
  }
}
